import { useAtomValue, useSetAtom, atom } from 'jotai';

// 10.1 — card billing for client memberships sits behind a server switch
// (MEMBERSHIP_CARD_BILLING_ENABLED) that /auth/me reports. `AuthProvider`
// mirrors it here so the membership forms can read it without depending on
// the whole auth context. Only an explicit `true` shows card billing — until
// /auth/me answers, the card controls stay hidden instead of flashing.
const membershipCardBillingEnabledAtom = atom(false);

// Write-only, for `AuthProvider`, the root of the whole app
export const useSetMembershipCardBillingEnabled = () =>
  useSetAtom(membershipCardBillingEnabledAtom);

export const useMembershipCardBillingStore = () => {
  const cardBillingEnabled = useAtomValue(membershipCardBillingEnabledAtom);

  return { cardBillingEnabled };
};
